import * as Ariakit from '@ariakit/react';
import { forwardRef } from 'react';

export interface RoleProps extends React.ComponentPropsWithoutRef<'div'> {
  children?: React.ReactElement;
}

export const Role = forwardRef<HTMLDivElement, RoleProps>(
  function Role({ children, ...props }, ref) {
    return <Ariakit.Role ref={ref} {...props} render={children} />;
  }
);
